const Menu = [
    {
      id: 1,
      image: "images/maggi.jpg",
      name: "maggi",
      category: "breakfast",
      price: "12₹",
      description:
        "Looking for a quick and delicious meal that will satisfy your hunger? Look no further than our Maggi noodles! Our Maggi is a classic comfort food that has been enjoyed by generations around the world.",
    },
  
    {
      id: 2,
      image: "images/allupakoida.jpg",
      name: "Aalu Pakoda",
      category: "evening",
      price: "20₹",
      description:
        " aalu pakoda is perfect for sharing with friends and family, or as a quick snack for your busy schedule. It's a classic street food that has been enjoyed for generations, and we take pride in making it fresh and hot for your ultimate enjoyment.",
    },
    {
      id: 3,
      image: "images/corn.jpg",
      name: "Corn",
      category: "breakfast",
      price: "10₹",
      description:
        "Come and taste our delicious corn dish today and savor the sweet and savory flavors that will transport you to a world of culinary delight!",
    },
    {
      id: 4,
      image: "../images/chola.jpg",
      name: "Chhola",
      category: "lunch",
      price: "50₹",
      description:
        "Each bite of our chhola is a delightful explosion of flavors, with a perfect balance of sweet, tangy, and spicy notes that will tantalize your taste buds. Whether you're a fan of Indian cuisine or looking to try something new and exciting, our chhola dish is the perfect choice.",
    },
    {
      id: 5,
      image: "../images/pizza.jpg",
      name: "Pizza",
      category: "evening",
      price: "80₹",
      description:
        "Whether you're a fan of classic pepperoni, vegetarian, or looking for something a little more adventurous, our pizza has something for everyone. And with our generous portions and affordable prices, you can indulge in your favorite comfort food without breaking the bank.",
    },
    {
      id: 6,
      image: "../images/nonvegthali.jpg",
      name: "Non-Veg Thali",
      category: "dinner",
      price: "180₹",
      description:
        "Our non-veg thaali is perfect for those looking to indulge in the rich and exotic flavors of Indian cuisine. Whether you're a fan of classic dishes or looking to try something new and exciting, our non-veg thaali has something for everyone.",
    },
    {
      id: 7,
      image: "../images/sweet.jpg",
      name: "Sweets",
      category: "dinner",
      price: "60₹",
      description:
        "From our rich and creamy kulfi to our mouth-watering rasgulla, each of our sweets is a unique and flavorful experience that will transport you to a world of culinary delight. And with our generous portions and affordable prices, you can indulge in your favorite sweet treats without breaking the bank.",
    },
    {
      id: 8,
      image: "../images/rajmarice.jpg",
      name: "Rajma Rice",
      category: "lunch",
      price: "60₹",
      description:
        "Experience the rich and hearty flavors of our Rajma Rice, the perfect comfort food for any occasion! Our Rajma Rice is made from tender kidney beans simmered to perfection in a savory blend of spices, served over a bed of fluffy, fragrant basmati rice.",
    },
    {
      id: 9,
      image: "../images/samosa.jpg",
      name: "samosa",
      category: "evening",
      price: "10₹",
      description:
        "Our samosas are perfect for a quick snack or as an appetizer to share with friends and family. With its irresistible taste and aroma, it's no wonder why samosas are a beloved street food in many parts of the world. Come and savor the authentic taste of our samosas, freshly made and served hot for your enjoyment.",
    }
  ];
  
  export default Menu;